// src/plugins/csp.ts
export interface RouteCSP {
  [route: string]: string;
}

// 添加类型安全的 window 访问
const getWindow = (): (Window & typeof globalThis) | undefined => {
  return typeof window !== 'undefined' ? window : undefined;
};

export const initDynamicCSP = (routeCSP: RouteCSP) => {
  const win = getWindow();
  if (!win) return;

  // 初始化 CSP 处理器
  win.__DYNAMIC_CSP__ = {
    policies: {},
    updatePolicy: function(route: string) {
      const policy = this.policies[route];
      if (!policy) return;

      // 移除旧的 CSP meta 标签
      const oldMeta = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
      if (oldMeta) oldMeta.remove();

      // 创建新的 meta 标签
      const meta = document.createElement('meta');
      meta.httpEquiv = 'Content-Security-Policy';
      meta.content = policy;
      document.head.appendChild(meta);
      // console.log(`CSP updated for route ${route}: ${policy}`);
    },
    findPolicy: function (route: string) : string | undefined {
      // 精确匹配
      if (this.policies[route]) return this.policies[route];

      // 通配符匹配
      for (const [path, policy] of Object.entries(this.policies)) {
        if (path.endsWith('*') && route.startsWith(path.slice(0, -1))) {
          return policy;
        }
      }
    return undefined;
    }
  };

  // 设置策略
  win.__DYNAMIC_CSP__.policies = routeCSP;

  // 初始化当前路由策略
  const initialRoute = win.location.pathname;
  const matchedRoute = findMatchingRoute(initialRoute, routeCSP);

  if (matchedRoute && win.__DYNAMIC_CSP__) {
    win.__DYNAMIC_CSP__.updatePolicy(matchedRoute);
  }
};

export const updateRouteCSP = (route: string) => {
  const win = getWindow();
  if (win && win.__DYNAMIC_CSP__) {
    win.__DYNAMIC_CSP__.updatePolicy(route);
  }
};

function findMatchingRoute(currentPath: string, routeCSP: RouteCSP): string | undefined {
  return Object.keys(routeCSP).find(route =>
    route === currentPath ||
    (route.endsWith('*') && currentPath.startsWith(route.slice(0, -1)))
  );
}